import gql from 'graphql-tag';
import { OrderItem, ORDER_ITEM_FRAGMENT } from '../useOrder/order.rest';

export type ShipmentItemRelationship = {
  __typename: 'RestShipmentItemRelationship';
  id: string;
};

export type Shipment = {
  __typename: 'RestShipment';
  id: string;
  attributes: {
    __typename: 'RestShipmentAttributes';
    createdAt: string;
    orderCreatedAt: string;
    orderId: number;
    orderNumber: string;
    shipmentNumber: string;
    shipmentStatus: {
      __typename: 'RestShipmentStatus';
      id: string;
      name: string;
    };
    shipmentType: string;
    returnMethod: string;
    shippedOn: string;
    trackingUrl: string;
  };
  relationships: {
    __typename: 'RestShipmentRelationships';
    orderItems: {
      __typename: 'RestShipmentItems';
      data: ShipmentItemRelationship[];
    };
  };
};

export type GetShipmentQueryVariables = {
  shipmentNumber: string;
  countryCode: string;
};

export type GetShipmentQuery = {
  getShipment: {
    __typename: 'RestShipmentPayload';
    data: Shipment[];
    included: OrderItem[];
  };
};

export const SHIPMENT_FRAGMENT = gql`
  fragment ShipmentFragment on RestShipment {
    id
    attributes @type(name: "RestShipmentAttributes") {
      createdAt: created_at
      orderCreatedAt: order_created_at
      orderId: order_id
      orderNumber: order_number
      shipmentNumber: shipment_number
      shipmentStatus: shipment_status @type(name: "RestShipmentStatus") {
        id
        name
      }
      shipmentType: shipment_type
      returnMethod: return_method_display
      shippedOn: shipped_on
      trackingUrl: tracking_url
    }
    relationships @type(name: "RestShipmentRelationships") {
      orderItems: order_items @type(name: "RestShipmentItems") {
        data @type(name: "RestShipmentItemRelationship") {
          id
        }
      }
    }
  }
`;

export const GET_SHIPMENT_QUERY = gql`
  query GetShipmentQuery($shipmentNumber: string!, $countryCode: String!) {
    getShipment(shipmentNumber: $shipmentNumber, countryCode: $countryCode)
      @rest(
        type: "RestShipmentPayload"
        endpoint: "shipments"
        path: "/v3.5/shipments?shipment_number={args.shipmentNumber}&include=order_items&country_code={args.countryCode}"
      ) {
      data @type(name: "RestShipment") {
        ...ShipmentFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
    }
  }
  ${SHIPMENT_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;
